import React, { useState } from 'react';
import PropTypes from 'prop-types';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import { insertMedia } from '../../../redux/actions/project';
import { useDispatch } from 'react-redux';
import '../../Drawings/NewDrawing/drwaing.scss';

const NewMedia = ({ projectId, open, handleClose, handleOk }) => {
  const dispatch = useDispatch();
  const [files, setFiles] = useState([]);

  const save = () => {
    const formData = new FormData();
    files.forEach((file) => {
      formData.append('file', file);
    });
    dispatch(
      insertMedia(projectId, formData, () => {
        handleOk();
      })
    );
  };

  const onFileSelect = (e) => {
    setFiles([...files, ...e]);
  };

  const remove = (index) => {
    const newFiles = [...files];
    newFiles.splice(index, 1);
    setFiles(newFiles);
  };

  return (
    <Dialog maxWidth="md" fullWidth onClose={handleClose} open={open}>
      <DialogTitle>New Media</DialogTitle>
      <DialogContent dividers>
        <div className="drawing">
          {files.map((file, i) => (
            <div className="drawing__pic" key={i} onClick={() => remove(i)}>
              <span>{file.name}</span>
            </div>
          ))}
          <label className="drawing__pic" htmlFor="mediainput">
            <span>Add Media</span>
          </label>
          <input id="mediainput" type="file" multiple onChange={(e) => onFileSelect(e.target.files)} />
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={save} color="primary" disabled={files.length === 0}>
          Save
        </Button>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

NewMedia.propTypes = {
  projectId: PropTypes.number.isRequired,
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  handleOk: PropTypes.func
};

export default NewMedia;
